/* eslint-disable react/no-array-index-key */
import React from 'react'
import { useStoreState } from 'easy-peasy'
import styled from 'styled-components'
import Transition from './Transition'
import LandingConsumer from './LandingConsumer'
import AnalyticsHandler from '../analytics/analiticsHandler'

const Container = styled.div`
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  padding-bottom: 0;
  p {
    text-rendering: optimizeLegibility;
    font-smooth: auto;
  }

  strong,
  b {
    font-weight: bold !important;
  }
`

export default function Main() {
  const [
    pages,
    { consumed, state },
    { country, language },
  ] = useStoreState(state => [
    state.steps.pages,
    state.scanData.data,
    state.locale.items,
  ])

  AnalyticsHandler.pushPage(country, language)
  AnalyticsHandler.pushVirtualPage(state, country, consumed)

  // check if state is VALID but consumed is true or ERROR or INACTIVE or BLACK_LIST and send Analytics getEventQRError
  if (
    (state === 'VALID' && consumed === true) ||
    state === 'ERROR' ||
    state === 'INACTIVE' ||
    state === 'BLACK_LIST'
  ) {
    const stateLower =
      state === 'VALID' ? 'consumed' : state.toLowerCase()
    AnalyticsHandler.getEventQRError(country, stateLower)
  }

  return (
    <Container>
      <LandingConsumer>
        {pages.map(({ type }, index) => (
          <Transition
            key={`page-${index}`}
            step={index}
            type={type}
          />
        ))}
      </LandingConsumer>
    </Container>
  )
}
